import { DefaultModelProperty, LabelValue } from '../standard'
import ContentCreator from './content-creator-model'
import contentCreatorProperties from './contentCreator-properties'
import { ContentCreatorProperties } from './contentCreator-property-definitions'

export async function OnEvents(
  eventType: string,
  form: ContentCreator,
  property: CategoryProperties,
): Promise<ContentCreator> {
  switch (eventType) {
    case 'change':
      return await change(property, form)

    default:
      break
  }
  return form
}
export function IsDisabled(property: ContentCreatorProperties): boolean {
  switch (property) {
    default:
      return false
  }
}

export function IsVisible(property: ContentCreatorProperties): boolean {
  switch (property) {
    case ContentCreatorProperties.Owner:
      return false
    case ContentCreatorProperties.Id:
      return false
    case ContentCreatorProperties.Created:
      return false
    case ContentCreatorProperties.Updated:
      return false
    case ContentCreatorProperties.Deleted:
      return false
    case ContentCreatorProperties.Version:
      return false
    case 'contentHouseId':
      return false
    default:
      return true
  }
}
async function change(
  property: CategoryProperties,
  value: ContentCreator,
): Promise<ContentCreator> {
  switch (property) {
    default:
      return value
  }
  return value
}
function getModelProperties(): DefaultModelProperty<ContentCreatorProperties>[] {
  return contentCreatorProperties as DefaultModelProperty<ContentCreatorProperties>[]
}
export function GetPageProperties(): DefaultModelProperty<ContentCreatorProperties>[] {
  function getPagePropertyPosition(property: string) {
    switch (property) {
      default:
        return 20
    }
  }
  return AssignUIComponent(
    getModelProperties()
      .filter((x: DefaultModelProperty<ContentCreatorProperties>) => {
        return getPagePropertyPosition(x.name) !== -1
      })
      .sort((a, b) => {
        return getPagePropertyPosition(a.name) - getPagePropertyPosition(b.name)
      })
      .map((v: DefaultModelProperty<ContentCreatorProperties>) => {
        return v
      }),
  )
}

export function DropdownOptions(
  property: ContentCreatorProperties,
): LabelValue<any>[] {
  switch (property) {
    default:
      return []
      break
  }
  return []
}
export function IsRequired(property: ContentCreatorProperties): boolean {
  switch (property) {
    case ContentCreatorProperties.Owner:
      return false
    case ContentCreatorProperties.Id:
      return false
    case ContentCreatorProperties.Created:
      return false
    case ContentCreatorProperties.Updated:
      return false
    case ContentCreatorProperties.Deleted:
      return false
    case ContentCreatorProperties.Version:
      return false
    default:
      return true
  }
}
export function AssignUIComponent(
  properties: DefaultModelProperty<ContentCreatorProperties>[],
): DefaultModelProperty<ContentCreatorProperties>[] {
  return properties.map(
    (modelProperty: DefaultModelProperty<ContentCreatorProperties>) => {
      switch (modelProperty.name) {
        default:
          switch (modelProperty.name) {
            case ContentCreatorProperties.ProfileImage:
              modelProperty.type = 'view-content-creator-profile-image'

              break
            default:
              break
          }

          break
      }
      return modelProperty
    },
  )
}
